import { Button, FormField, Modal, Switch } from '@loomhq/lens';
import React, { useState } from 'react';

import { LOCAL_THEME, THEME_DARK } from '../../hooks/useTheme';

const DarkModeToggle = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(
    localStorage.getItem(LOCAL_THEME) === THEME_DARK
  );

  const handleDarkModeChange = () => {
    localStorage.setItem(LOCAL_THEME, THEME_DARK);
    document.body.classList.add(THEME_DARK);

    setDarkMode(true);
    setModalIsOpen(false);
  };

  const handleToggleChange = () => {
    if (!darkMode) {
      setModalIsOpen(true);
    } else {
      localStorage.setItem(LOCAL_THEME, '');
      document.body.classList.remove(THEME_DARK);
      setDarkMode(false);
    }
  };

  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onCloseClick={() => setModalIsOpen(false)}
        title="Before enabling dark mode"
        mainButton={
          <Button variant="primary" onClick={() => handleDarkModeChange()}>
            I understand, enable dark mode
          </Button>
        }
        secondaryButton={
          <Button onClick={() => setModalIsOpen(false)}>Cancel</Button>
        }
        onBackgroundClick={() => setModalIsOpen(false)}
      >
        Dark mode is currently only available for Loom internal usage, only Loom
        members can see the dark mode switch. Some colors may not display
        correctly.
      </Modal>

      <FormField direction="row" label="Dark mode" labelFor="darkMode">
        <Switch
          id="darkMode"
          isActive={darkMode}
          onChange={() => handleToggleChange()}
        />
      </FormField>
    </div>
  );
};

export default DarkModeToggle;
